import {ConversationStageType} from '@frontapp/insights/conversation_stages';
import {darken} from 'polished';

// eslint-disable-next-line rulesdir/no-color-imports
import {NewPaletteColorsEnum, palette} from '../../../libs/shared/ui/src/styles/colorStyles';
import {AnalyticsDataPoint, AnalyticsTableMetric} from '../../models/api/analyticsMetricsModel';
import {ProgressSerie} from '../components/charts/components/progressBar/progressBarSerie';
import {TableToProgressTransformer} from './analyticsMetricsTransformers';
import {
  AnalyticsComputedMetricTypesEnum,
  AnalyticsComputedProgressMetricBase,
  AnalyticsComputedProgressMetricsEnum,
} from './analyticsMetricsTransformersTypes';

/*
 * Transformer.
 */

export const pctStageResolvedSegmentsToProgress: TableToProgressTransformer = (
  metricData: AnalyticsTableMetric | undefined,
): AnalyticsComputedProgressMetricBase => {
  const transformedMetricBase = {
    id: AnalyticsComputedProgressMetricsEnum.STAGE_RESOLVED_SEGMENTS_PROGRESS,
    metricType: AnalyticsComputedMetricTypesEnum.CUSTOM_PROGRESS,
    isEmpty: metricData?.isEmpty ?? false,
  };

  if (!metricData) {
    return {
      ...transformedMetricBase,
      series: [],
    };
  }

  const unresolvedRow = metricData.rows.find((row) =>
    row.find((dataPoint) => dataPoint.value === ConversationStageType.UNRESOLVED),
  );
  const resolvedRow = metricData.rows.find((row) =>
    row.find((dataPoint) => dataPoint.value === ConversationStageType.RESOLVED),
  );
  const ignoredRow = metricData.rows.find((row) =>
    row.find((dataPoint) => dataPoint.value === ConversationStageType.IGNORED),
  );

  const series: ReadonlyArray<ProgressSerie> = [
    {
      color: palette[NewPaletteColorsEnum.BLUE].shade20,
      hoverColor: darken(0.02, palette[NewPaletteColorsEnum.BLUE].shade20),
      ...generateRowValues(unresolvedRow),
    },
    {
      color: palette[NewPaletteColorsEnum.GREEN].shade20,
      hoverColor: darken(0.02, palette[NewPaletteColorsEnum.GREEN].shade20),
      ...generateRowValues(resolvedRow),
    },
    {
      color: palette[NewPaletteColorsEnum.GREY].shade20,
      hoverColor: darken(0.02, palette[NewPaletteColorsEnum.GREY].shade20),
      ...generateRowValues(ignoredRow),
    },
  ];

  return {
    ...transformedMetricBase,
    series,
  };
};

/*
 * Helpers.
 */

function generateRowValues(row: ReadonlyArray<AnalyticsDataPoint> | undefined) {
  const pctTotal = +(row?.[1].value ?? 0);
  const countTotal = +(row?.[2].value ?? 0);
  const pctClosed = +(row?.[3].value ?? 0);

  return {
    value: Math.round(pctTotal * 100),
    extra: {count: countTotal, pctClosed: Math.round(pctClosed * 100)},
  };
}
